<template>
    <div v-if="open" class="modal-wrapper">
        <div class="modal-container">
            <div class="modal">
                <form action @submit.prevent="onSubmit" ref="form">
                <csrf></csrf>
                <div class="standard-form">
                    <div class="general-title">
                        <div class="title">Enter Kid Mode for {{ child.first_name }}</div>
                        <div class="buttons-container buttons">
                            <a href @click.prevent="open = false" class="neutral-bg">Cancel<span class="fa fa-times-circle"></span></a>
                        </div>
                    </div>
                    <div class="input-container">
                        <div class="input-box static-text">Launch Kid Mode by entering a one-time-use code. Once your child is done with this session, you must enter the same code to exit Kid Mode.</div>
                    </div>

                    <div v-if="errors.length > 0" class="alert alert-bad">
                        <ul>
                            <li v-for="error in errors" :key="error"><span class="fa fa-flag"></span>{{ error }}</li>
                        </ul>
                    </div>

                    <div class="input-container">
                        <div class="input-title">Enter Your Code</div>
                        <div class="input-box"><input type="password" name="pin" v-model="form.pin" maxlength="4" required autocomplete="pin"></div>
                    </div>
                    <div class="input-container">
                        <div class="input-title">Confirm Your Code</div>
                        <div class="input-box"><input type="password" name="pin_confirmation" v-model="form.pin_confirmation" maxlength="4" required autocomplete="pin"></div>
                    </div>
                    <button v-if="!loading" type="submit" class="submit-standard good-bg">Enter Kid Mode Now <span class="fa fa-smile"></span></button>
                    <button v-if="loading" type="submit" class="submit-standard neutral-bg" disabled>Processing...<span class="fa fa-smile"></span></button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import apiErrors from '@/utils/apiErrors';

export default {

    data() {
        return {
            open: false,
            loading: false,
            errors: [],
            form: {},
        };
    },

    computed: mapGetters([ 'child' ]),

    mounted() {
        this.$root.$on('kid-mode-modal', () => {
            this.open = true;
        })
    },

    methods: {

        async onSubmit() {
            this.loading = true;
            this.errors = [];

            try {
                await axios.post('/account/kid-mode', new FormData(this.$refs.form));

                window.location.href = '/dashboard';
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors) {
                    Object.values(e.response.data.errors).forEach(errors => {
                        errors.forEach(error => {
                            this.errors.push(error);
                        });
                    });

                } else {
                    this.errors = [ apiErrors.getErrorMessage(e) ];
                }

                this.loading = false;
            }

        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/modals/EnterKidModeModal.vue